export const preSurgery = {
	confirmed_team: "",
	confirmed_patient_data: "",
	resource_structuring_present: "",
	requested_opsm_present: "",
	prophylactic_antimicrobial_administered: "",
	critical_steps_in_surgery: "",
	estimated_duration: "",
	specific_concern_patient: "",
	correct_sterilization_on_expiration_date: "",
	concern_about_equipment_materials: "",
	needs_exams_xr_freezing: "",
	cribs_and_heated_fields: "",
	responsible_professional_id: "",
};
